import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _jsxFileName = "/home/christian/DEV/workspace/crossbuilders/form-library/src/lib/components/fields/RangeSlider/index.jsx";
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import '../../../assets/scss/3_components/_form-range-slider.scss';
import FormHint from '../../structure/FormHint';
import FormRow from '../../structure/FormRow';
import Label from '../../structure/Label';
import { inputDefaultProps, inputPropTypes } from '../../../commonProps';
function RangeSliderComponent(props) {
  var id = props.id,
    name = props.name,
    inputRef = props.inputRef,
    children = props.children,
    inputClass = props.inputClass,
    errorClass = props.errorClass,
    labelClass = props.labelClass,
    rowClass = props.rowClass,
    min = props.min,
    max = props.max,
    step = props.step,
    value = props.value,
    onChange = props.onChange,
    disabled = props.disabled,
    readOnly = props.readOnly,
    required = props.required,
    errors = props.errors,
    warning = props.warning,
    info = props.info;
  var getSteppedValue = function getSteppedValue(val) {
    var getRoundedValue = function getRoundedValue() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return Math.round((v + Number.EPSILON) * 100) / 100;
    };
    var parsedValue = getRoundedValue(parseFloat(val || min));
    var parsedStep = parseFloat(step || 1);
    var remaining = getRoundedValue(parsedValue % parsedStep);
    if (remaining >= parsedStep / 2) {
      return getRoundedValue(parsedValue + parsedStep - remaining);
    }
    return Math.min(max, Math.max(min, parsedValue - remaining));
  };
  var handleOnChange = function handleOnChange(event) {
    onChange(getSteppedValue(event.target.value));
  };
  var hasErrors = errors && Object.hasOwnProperty.call(errors, name);
  var errorMessage = hasErrors ? errors[name].message : null;
  var inputClassName = hasErrors ? "".concat(inputClass, " ").concat(errorClass) : inputClass;
  return /*#__PURE__*/React.createElement(FormRow, {
    className: rowClass,
    hasErrors: hasErrors,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Label, {
    id: id,
    className: labelClass,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 13
    }
  }, children), /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    id: id,
    name: name,
    type: "range",
    className: inputClassName,
    min: min,
    max: max,
    step: step,
    value: getSteppedValue(value),
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onChange: handleOnChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(FormHint, {
    error: errorMessage,
    warning: warning,
    info: info,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 13
    }
  }));
}
export default function RangeSlider(props) {
  var _this = this;
  return /*#__PURE__*/React.createElement(Controller, Object.assign({
    defaultValue: 0
  }, props, {
    render: function render(_ref) {
      var onChange = _ref.onChange,
        onBlur = _ref.onBlur,
        value = _ref.value;
      return /*#__PURE__*/React.createElement(RangeSliderComponent, Object.assign({}, props, {
        onChange: onChange,
        onBlur: onBlur,
        value: value || 0,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87,
          columnNumber: 13
        }
      }));
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 9
    }
  }));
}
RangeSlider.propTypes = _objectSpread(_objectSpread({}, inputPropTypes), {}, {
  min: PropTypes.string,
  max: PropTypes.string,
  step: PropTypes.string
});
RangeSlider.defaultProps = _objectSpread(_objectSpread({}, inputDefaultProps), {}, {
  inputClass: 'form-range-slider',
  errorClass: 'form-range-slider--has-error',
  min: null,
  max: null,
  step: '1'
});